<div
  #host
  class="notification"
  [ngClass]="{ visible: visible, 'right-side': rightside }"
  [style.top.px]="top"
  [style.left.px]="left">
  <div class="message text">
    {{ message }}
    <span class="alternatives" *ngIf="useAlternatives">
      <app-input-alternatives [source]="parent"></app-input-alternatives>
    </span>
  </div>
  <div [ngClass]="{ arrow: !rightside, 'arrow-right': rightside }"></div>
</div>
